import { action, createAsyncAction } from 'typesafe-actions';
import { HttpStatus } from 'client/ErrorHandler';
import {
  StatementTypes,
  StatementResponse,
  StatementRequestPayload,
} from './types';

const statementListActions = createAsyncAction(
  StatementTypes.FetchListRequest,
  StatementTypes.FetchListSuccess,
  StatementTypes.FetchListFailure
)<StatementRequestPayload, StatementResponse, HttpStatus>();

export const resetList = () => action(StatementTypes.ListReset);

export default statementListActions;
